/**
 * Input Schema of ResponseRoboCnpj
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponseRoboCnpj} from '@/model/resource/ResponseRoboCnpj'

/* TODO: review generated schema */
export class InputResponseRoboCnpjSchema extends Schema {
  readonly name = 'InputResponseRoboCnpj'

  readonly fieldSet: FieldSet<ResponseRoboCnpj> = {
    cnpj: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'cnpj',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required|cnpj',
      },
    }),
    response: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
